export default "__VITE_ASSET__CDZoF1p7__"